// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"dd2ffe00","59":"214cad10","156":"625db675","320":"16ecf842","492":"c667ca75","787":"cd553f92"}[chunkId] + ".chunk.js";
};